import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46837420"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-label" }, "カテゴリ名", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("更新")

import { ref, withDefaults, watch } from "vue"

interface Props {
  modelValue: boolean;
  targetId: number;
  targetName: string;
}
interface Emits {
  (e: 'updateCategory', _target_id: number, _value: string): void
  (e: "update:model-value", value: boolean): void;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean, required: true, default: false },
    targetId: { type: Number, required: true },
    targetName: { type: String, required: true }
  },
  emits: ["updateCategory", "update:model-value"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'updateCategory', _target_id: number, _value: string): void
  (e: "update:model-value", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean, targetId: number, targetName: string }



let name = ref('');
watch(() => props.targetName, () => {
  name.value = props.targetName
})
const updateCategory = () => {
  if (name.value.length > 0) {
    emit("updateCategory", props.targetId, name.value)
  }

  // name.value = ""
}

const handleClosed = (): void => {
  emit('update:model-value', false);
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": __props.modelValue,
    onClosed: handleClosed,
    title: "名前変更",
    width: "30%",
    "destroy-on-close": ""
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: updateCategory,
        disabled: _unref(name).length == 0
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_el_form, {
          onSubmit: _withModifiers(updateCategory, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_el_input, {
                  placeholder: "Please input",
                  modelValue: _unref(name),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : name = $event)),
                  onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})